/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Voice_Manager_Elevenlabs_OfflineInputs */



/**
* | output |
* | --- |
* | "ElevenLabs voices need an internet connection." |
*
* @param {Voice_Manager_Elevenlabs_OfflineInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const voice_manager_elevenlabs_offline = /** @type {((inputs?: Voice_Manager_Elevenlabs_OfflineInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Voice_Manager_Elevenlabs_OfflineInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Les voix ElevenLabs nécessitent une connexion Internet.")
	if (locale === "de") return /** @type {LocalizedString} */ ("ElevenLabs-Stimmen benötigen eine Internetverbindung.")
	if (locale === "it") return /** @type {LocalizedString} */ ("Le voci ElevenLabs richiedono una connessione a Internet.")
	if (locale === "ru") return /** @type {LocalizedString} */ ("Для голосов ElevenLabs нужно подключение к интернету.")
	if (locale === "es") return /** @type {LocalizedString} */ ("Las voces de ElevenLabs necesitan conexión a internet.")
	if (locale === "zh-CN") return /** @type {LocalizedString} */ ("ElevenLabs 语音需要互联网连接。")
	if (locale === "ja") return /** @type {LocalizedString} */ ("ElevenLabs の音声にはインターネット接続が必要です。")
	if (locale === "hi") return /** @type {LocalizedString} */ ("ElevenLabs आवाज़ों के लिए इंटरनेट कनेक्शन आवश्यक है।")
	if (locale === "pt-PT") return /** @type {LocalizedString} */ ("As vozes da ElevenLabs requerem ligação à Internet.")
	return /** @type {LocalizedString} */ ("ElevenLabs voices need an internet connection.")
});